// extracted by mini-css-extract-plugin
export var category = "_kp-9";
export var categoryHeader = "_kp-e";
export var container = "_kp-0";
export var group = "_kp-a";
export var groupItems = "_kp-f";
export var groupSeparator = "_kp-j";
export var loading = "_kp-1";
export var noResults = "_kp-3";
export var placeholder = "_kp-2";
export var resultContent = "_kp-5";
export var resultIcon = "_kp-c";
export var resultItem = "_kp-g";
export var resultMeta = "_kp-8";
export var resultSubtitle = "_kp-7";
export var resultSuffix = "_kp-i";
export var resultTitle = "_kp-6";
export var resultsList = "_kp-4";
export var searchGroup = "_kp-d";
export var selected = "_kp-h";
export var subgroup = "_kp-b";